module.exports = __webpack_public_path__ + "img/airtke_base.c1eee63c.jpg";